<template>
    <jet-button
        :class="{ 'opacity-25': disabled }"
        :disabled="disabled"
        :secondary="true"
        type="button"
        :loading="loading"
        @click.native="$emit('click')"
    >
        <template v-if="isNextButton">
            <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5"><path d="M9 5l7 7-7 7"></path></svg>
        </template>
        <template v-else>
            <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24" class="w-5 h-5"><path d="M15 19l-7-7 7-7"></path></svg>
        </template>
    </jet-button>
</template>


<script>
import axios from 'axios';
import {mapWritableState, mapActions} from 'pinia';
import { useGeneralTableStore } from '../../Stores/general_table';
import JetButton from '../../Jetstream/Button.vue';


export default {
    name: 'PaginationButton',
    emits: ['click'],
    props: {
        'isNextButton': {
            type: Boolean,
            default: false,
        },
        'disabled': {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        JetButton,
    },
    mounted() {
    },
    computed: {
        ...mapWritableState(useGeneralTableStore, [
            'data',
            'page',
            'perPage',
            'search',
            'orderBy',
            'orderByDir',
            'items',
            'total',
        ]),
        
    },
}
</script>
